import mixpanel from 'mixpanel-browser';
const isProd = (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'development') && window.location.hostname !== "localhost" ? true : false
mixpanel.init('e49c6a5136f189de580ebeb1986c12b6');

export default function useMixPanelEvent() {
    const event = (category = "Default", label = "default", value = "default") => {
        return isProd ? mixpanel.track(category, {
            'source': 'Advisor Finder',
            [label]: value
        }) : null;
    }
    return event;
}